import React from 'react'
import SanityLink from '@/lib/SanityLink'

const FooterNav = ({ nav }) => (
	<nav className="flex flex-wrap <md:flex-col gap-4 justify-between">
		{nav?.map(({ label, items }, key) => (
			<div key={key}>
				<p className="h4 mb-2">{label}</p>

				<ul className="grid gap-2">
					{items?.map((item, key) => (
						<li key={key}>
							<SanityLink className="hover:underline" {...item} />
						</li>
					))}
				</ul>
			</div>
		))}
	</nav>
)

export default FooterNav
